import React from 'react';
import { Link } from 'react-router-dom';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import { Button, Paper } from '@material-ui/core'; 
import { KeyboardDatePicker } from "@material-ui/pickers";
import CalendarToday from '@material-ui/icons/CalendarToday';
import Lock from '@material-ui/icons/Lock';
import LockOpen from '@material-ui/icons/LockOpen';

import style from './whsOrdersList.module.css';
import commonStyles from '../../common/common.module.css';

import OrderWhs from '../../../models/OrderWhs';
import { OrderLockStatusType } from '../../../models/OrderLockStatusType.enum';

import { Moment } from 'moment';

import { truckStatusTime } from '../../../utils/truckStatusTime';
import { Lens } from '@material-ui/icons';

const styles = (theme: Theme) =>

  createStyles({
    datePickerInput: {
      width: '160px',
      '& input': {
        padding: '0 0 0 15px',
        fontSize: '14px'
      }
    },
    grey: {
      color: 'grey'
    },
    blue: {
      color: 'var(--primaryblue)'
    },
    green: {
      color: 'rgb(66, 183, 70)'
    },
    lens: {
      position: 'absolute',
      color: 'black',
      fontSize: '6px',
      fontWeight: 'normal',
      border: '1px solid black',
      height: '20px',
      marginLeft: '10px'
    },
    wrapper: {
      marginTop: '14px',
    },
  });

interface WhsOrdersListProps {
  classes: any;
  orders: OrderWhs[];
  orderDate: Moment;
  dateChange: (date: Moment) => void;
  type: string;
  hover: Function;
};

const whsOrdersList = (props: WhsOrdersListProps) => {

  const { classes, orders, type } = props;

  return (
    <div className={ style.wrapper }>
      <div className={ style.dataWrapper }>
        <span className={ style.dockText }>Dock activity</span>
        <KeyboardDatePicker
          autoOk
          format='DD MMM YYYY'
          value={ props.orderDate }
          onChange={(date: any) => props.dateChange(date) }
          InputProps={{ 
            className: classes.datePickerInput,
            disableUnderline: true
          }}
        />
      </div>
      <div className={ `${ commonStyles.wrapper } ${ classes.wrapper }` }>
        <h3 className={ `${ commonStyles.header }` }> Order Details</h3>
        <MaterialTable

          components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}

          data={ orders } 

          columns={[
            { title: 'Order #', field: 'number', cellStyle: { cursor: 'pointer', color: '#003261', textDecoration: 'underline', paddingLeft: '2%', paddingRight: '2%'}, headerStyle: { paddingLeft: '2%', paddingRight: '2%'},
            render: (rowData: OrderWhs) => {
              return <span>
                  <Link to={`/whs/${type}/${rowData.number}?start=${true}`} >{ rowData.number }{ (rowData as any).was_go === 'true' || (rowData as any).was_go === true ? ' (GO)' : '' }</Link>
                  { rowData.specials && <Button onClick={ () => props.hover(rowData.number) } className={ classes.lens } style={{ fontSize: 14 }}>Specials</Button>}
                </span>;
            }
            },
            { title: 'Trucker', field: 'delivery_company_name', cellStyle: {paddingLeft: '2%', paddingRight: '2%'}, headerStyle: { paddingLeft: '2%', paddingRight: '2%'}  },
            {
              title: 'Status', field: 'truck_status',
              render: (rowData: OrderWhs) => {
                return truckStatusTime(rowData);
              }, cellStyle: {paddingLeft: '2%', paddingRight: '2%'}, headerStyle: { paddingLeft: '2%', paddingRight: '2%'} 
            },
            { title: 'Lock', field: 'lock_status',
              render: (rowData: OrderWhs) => {
          
                  if( rowData.lock_status !== OrderLockStatusType.UNLOCKED){
                    const color = rowData.lock_status === OrderLockStatusType.LOCKED ? `${ classes.blue }`: `${ classes.gray }`;
                    return (
                      <Lock className={ color }/>
                    )
                  }
                  return (
                    <LockOpen className={ classes.green } />
                  )
              },cellStyle: {paddingLeft: '2%', paddingRight: '2%'}, headerStyle: { paddingLeft: '2%', paddingRight: '2%'}  
            },
          ]}

          options={{
            paging: false,
            pageSize: 10,
            headerStyle: {
              backgroundColor: 'var(--tbl_head_bkg)',
              color: 'var(--tbl_head_color)',
              zIndex: 2,
            },
            showTitle: false,
            pageSizeOptions: [15, 20],
            toolbar: false,
            sorting: false
          }}
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(whsOrdersList);